import AsyncStorage from "@react-native-async-storage/async-storage"
import type { ClientDataStorageAdapter } from "@taskfortress/core"

/**
 * Mobile implementation of ClientDataStorageAdapter using React Native's AsyncStorage
 */
export class ClientDataLocalStorageAdapter implements ClientDataStorageAdapter {
  private _storageKey: string = ""

  get storageKey(): string {
    return this._storageKey
  }

  set storageKey(value: string) {
    this._storageKey = value
  }

  private get PREFIX(): string {
    return `${this._storageKey}:`
  }

  private _getKey(key: string): string {
    return `${this.PREFIX}${key}`
  }

  async getItem(key: string): Promise<string | null> {
    try {
      return await AsyncStorage.getItem(this._getKey(key))
    } catch (error) {
      console.error("Error getting item from AsyncStorage", error)
      return null
    }
  }

  async setItem(key: string, value: string): Promise<void> {
    try {
      await AsyncStorage.setItem(this._getKey(key), value)
    } catch (error) {
      console.error("Error setting item in AsyncStorage", error)
    }
  }

  async removeItem(key: string): Promise<void> {
    try {
      await AsyncStorage.removeItem(this._getKey(key))
    } catch (error) {
      console.error("Error removing item from AsyncStorage", error)
    }
  }
}
